import React, { useEffect, useState } from 'react'
import CopaLogo from '../../../assets/logo-copa.svg?react'
import { ThinkingStep } from 'src/enviroment/api/chat/models'
import { useElapsedSeconds } from 'src/enviroment/hooks/useElapsedSeconds'

type Props = {
  steps: ThinkingStep[]
  startedAt: number
  showElapsed?: boolean
  fallbackLabel?: string
}

const CYCLE_MS = 3000

const isRunning = (step: ThinkingStep) => step.status === 'running'
const isParallel = (step: ThinkingStep) => step.type === 'parallel'

const latestRunningLabel = (steps: ThinkingStep[]) =>
  [...steps].reverse().find(isRunning)?.step ?? steps[steps.length - 1]?.step ?? ''

const ThinkingIndicator: React.FC<Props> = ({ steps, startedAt, showElapsed = true, fallbackLabel = 'Thinking…' }) => {
  const [tick, setTick] = useState(0)
  const elapsedSeconds = useElapsedSeconds(startedAt)

  const parallelLabels = steps.filter(isParallel).map((s) => s.step)
  const isCycling = parallelLabels.length > 1 && steps.some((s) => isRunning(s) && isParallel(s))

  useEffect(() => {
    if (!isCycling) return
    const id = setInterval(() => setTick((t) => t + 1), CYCLE_MS)
    return () => clearInterval(id)
  }, [isCycling])

  const label = (isCycling ? parallelLabels[tick % parallelLabels.length] : latestRunningLabel(steps)) || fallbackLabel

  return (
    <div className="flex items-center gap-2">
      <CopaLogo width={24} height={24} className="shrink-0" />
      <div key={label} className="animate-fade-in-up">
        <p className="animate-shimmer bg-shimmer-text bg-200 bg-clip-text text-base font-medium italic leading-6 text-transparent">
          {label}
        </p>
      </div>
      {showElapsed && <span className="shrink-0 text-sm tabular-nums text-gray-400">{elapsedSeconds}s</span>}
    </div>
  )
}

export default ThinkingIndicator
